import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  action: {
    marginTop: 6,
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontSize: theme.size.sm
  }
}))

export default useStyles
